module.exports = __webpack_public_path__ + "img/ercode.9b704e73.jpg";